import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { AuthRefreshInterceptor } from './core/interceptors/auth-refresh.interceptor';
import { ForbiddenInterceptor } from './core/interceptors/forbidden.interceptor';
import { provideTranslation } from './core/providers/translate.provider';
import { AuthService } from './core/services/auth/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes),
  provideAnimationsAsync(),
  providePrimeNG({
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: '.my-app-dark',
        cssLayer: {
          name: 'primeng',
          order: 'tailwind, primeng',
        },
      }
    }
  }),
  importProvidersFrom(HttpClientModule),
  ...provideTranslation(),
  {
    // Refresh proactivo al arrancar: si el access token expiró pero hay refresh
    // token, renueva la sesión antes de que la app cargue rutas/datos.
    provide: APP_INITIALIZER,
    multi: true,
    deps: [AuthService],
    useFactory: (auth: AuthService) => () =>
      firstValueFrom(auth.ensureValidSession()).catch(() => false)
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthRefreshInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ForbiddenInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
  }


]
};
